import projectsApi from '@/api/v1/projects';

export default {
  namespaced: true,

  state: {
    projectsList: [],
  },

  mutations: {
    SET_PROJECTS(state, projects) {
      state.projectsList = projects;
    },
  },

  actions: {
    fetchProjects({ commit }) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      return projectsApi.shortAcceptance.index()
        .then((response) => {
          commit('SET_PROJECTS', response.data);
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },
  },
};
